import React from 'react'
import Modal from 'react-bootstrap/lib/Modal'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

/* Actions */
import * as modalActionCreators from '../../actions/modals'
import * as signUpActionCreators from '../../actions/signUp'

/* Centralized Proptypes */
import { currentUserPropTypes } from '../../constants/composed-proptypes'

const HostConfirmationModal = props => {
  const { show, modalActions, currentUser } = props
  return (
    <Modal
      show={show}
      onHide={() => modalActions.hideHostConfirmation()}
      animation={false}
      className="user-confirmation-modal"
    >
      <Modal.Header closeButton />
      <Modal.Body>
        <div className="modal-inner modal-inner--centered">
          <h4>
            {currentUser.attributes.firstName}, thank you for applying to become
            a host.!
          </h4>
          <h5>
            Your application has been sent and is currently being reviewed.
          </h5>
          <p>Meanwhile, feel free to enjoy our unique dining experiences </p>
          <Link
            to="/experiences"
            className="btn explore-expirence-btn"
            onClick={() => modalActions.hideUserConfirmation()}
          >
            Explore Experiences
          </Link>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="text-center">
          <button
            type="button"
            className="btn btn--link"
            onClick={() => modalActions.hideHostConfirmation()}
          >
            Close Window
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

HostConfirmationModal.propTypes = {
  currentUser: currentUserPropTypes.isRequired,
  modalActions: PropTypes.shape({}).isRequired,
  show: PropTypes.bool.isRequired
}

const mapStateToProps = state => ({
  currentUser: state.reduxTokenAuth.currentUser
})

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(modalActionCreators, dispatch),
  signUpActions: bindActionCreators(signUpActionCreators, dispatch)
  /** NOTE: This would also be a nice way of doing it
   * https://github.com/reduxjs/react-redux/blob/master/docs/api.md#inject-todos-and-all-todoactioncreators-and-counteractioncreators-directly-as-props
   *
   * actions: bindActionCreators(Object.assign({}, modalActions), dispatch)
   */
})
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HostConfirmationModal)
